import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "components";
import { toastAlert } from "@paylixecommerce/shared/components";
import { getUserSettings } from "services/auth/actions";
import { saveNotificationSettings, checkDiscordChannel } from "./actions";
import { Formik } from "formik";
import { Switch, Text } from "components/fields";

import "./style.scss";
import "../../index.scss";


const Notification = ({ formRef }) => {

	let [loading, setLoading] = useState(true);
	let [isSafari, setSafari] = useState(false);
	let [initialValues, setInitialValues] = useState({
		discord_webhook_url: '',
		notifications_invoices: false,
		notifications_tickets: false,
		notifications_feedback: false,
		notifications_replies: false,
		notifications_product_updates: false,
		notifications_store_health: false,
		notifications_paylixecommerce: false
	});
	let dispatch = useDispatch();

	useEffect(() => {
		setSafari(/^((?!chrome|android).)*safari/i.test(window.navigator.userAgent))
	}, [])

	const getSettings = () => {
		dispatch(getUserSettings())
			.then(res => {

				const { notifications_product_updates, notifications_store_health, notifications_paylixecommerce, notifications_invoices, notifications_tickets, notifications_feedback, notifications_replies, discord_webhook_url } = res.data.settings.user

				setInitialValues({
					notifications_product_updates: notifications_product_updates,
					notifications_store_health: notifications_store_health,
					notifications_paylixecommerce: notifications_paylixecommerce,
					notifications_invoices: notifications_invoices,
					notifications_tickets: notifications_tickets,
					notifications_feedback: notifications_feedback,
					notifications_replies: notifications_replies,
					discord_webhook_url: discord_webhook_url || ""
				})
			})
			.finally(() => setLoading(false))
	}
	useEffect(() => {
		getSettings()
	}, []);


	const onSubmit = (values) => {
		setLoading(true)
		dispatch(saveNotificationSettings({
			notifications_invoices: Boolean(values.notifications_invoices),
			notifications_tickets: Boolean(values.notifications_tickets),
			notifications_feedback: Boolean(values.notifications_feedback),
			notifications_replies: Boolean(values.notifications_replies),


			notifications_product_updates: Boolean(values.notifications_product_updates),
			notifications_store_health: Boolean(values.notifications_store_health),
			notifications_paylixecommerce: Boolean(values.notifications_paylixecommerce),

			discord_webhook_url: values.discord_webhook_url,
		}))
			.then(res => {
				toastAlert('success', res.message);
				getSettings()
			})
			.catch(err => toastAlert('error', (err && err.error) || 'Something went wrong!'))
			.finally(() => {
				setLoading(false);
			})
	}

	const testDiscordChannel = (discord_webhook_url) => {
		dispatch(checkDiscordChannel({ discord_webhook_url }))
			.then(() => toastAlert('success', "Discord Test Succeeded"))
			.catch((e) => toastAlert('error', e.error))
	}


	return (
		<Formik innerRef={formRef} initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
			{form => {
				if (document && document.getElementById && document.getElementById('submit-settings')) {
					let submitButton = document.getElementById('submit-settings');
					if (form.dirty) {
						submitButton.classList.remove('d-none');
						submitButton.classList.add('d-flex');
					} else {
						submitButton.classList.remove('d-flex')
						submitButton.classList.add('d-none')
					}
				}

				return <form onSubmit={form.handleSubmit} className="settings-content mb-0">
					<div className="settings-content-title">Notifications</div>
					<div className="position-relative">

						<Switch withBorder
								note="Receive an email when you make a new sale"
								name="notifications_invoices" label="Orders" {...form} left/>
						<Switch withBorder
								note="Receive an email when a ticket is replied"
								name="notifications_tickets" label="Tickets" {...form} left/>
						<Switch withBorder
								note="Receive an email when a feedback is created"
								name="notifications_feedback" label="Feedback" {...form} left/>
						<Switch withBorder
								note="Receive an email when a ticket is replied"
								name="notifications_replies" label="Ticket Reply" {...form} left/>
						<Switch withBorder
								note="Get an email when we release new features, updates or anything related to your store. We suggest leaving this enabled to be notified about your business."
								name="notifications_product_updates" label="Product Updates" {...form} left/>
						<Switch withBorder
								note="Receive emails to help you grow your business as well as best practices. Suggestions on how to keep a positive public image for both Paylix and your store."
								name="notifications_store_health" label="Store Health and Best Practices" {...form}
								left/>
						<Switch withBorder
								note="Allow the Paylix staff to send you friendly emails about social networks, blog posts or anything related to your social media experience and partnership!"
								name="notifications_paylixecommerce" label="Paylix Friendly Emails" {...form} left/>

						<div className="position-relative mt-4">
							<Text
								label="Discord Webhook URL"
								placeholder="https://discord.com/api/webhooks/exampleDiscordWebhookUrl"
								name="discord_webhook_url"
								note="Receive Paylix Notifications on your Discord Server. "
								noteUnder
								{...form}
							/>
							<Button onClick={testDiscordChannel.bind(this, form.values.discord_webhook_url)} disabled={!form.values.discord_webhook_url} className="discord-button" type="button">
								Send Test
							</Button>
						</div>
					</div>
				</form>
			}}
		</Formik>
	)
}


export default Notification
